<div class="trip-detail-popup">
  <p class="heading">Cancellaton & Refund Policy</p>
  <mat-divider></mat-divider>

  <p class="mb-4">
    our policy and cancellation options can always be found in your Trips. Just
    click or tap Show trip details and you'll find your Cancellation policy. The
    times and dates we display for cancellation policies are based on the local
    time zone of the listing. Cancellation deadlines for receiving refunds are
    measured from the check-in time for the listing in its local time zone, or
    3.00pm if no check-in time is specified.
  </p>
  <p class="mb-4">
    If you want to know what your refund will be, start cancelling your
    reservation and we’ll show you a detailed breakdown. Depending on the length
    of your stay, when you cancel, and the cancellation policy that applies to
    your reservation, you may get a partial refund if you cancel after check-in
    – learn more about different cancellation policies.
  </p>
  <p class="mb-4">
    Learn more about how refunds work for cancellations. Remember that the
    amount refunded will never be more than the amount you have actually paid at
    the time you cancel – learn more about refund amounts.
  </p>
  <p>Extenuating circumstances</p>
  <p class="mb-4">
    Did an emergency or natural disaster disrupt your reservation? You may be
    eligible for a refund due to extenuating circumstances. If you need to
    cancel because of the COVID-19 pandemic, learn about your options.
  </p>

  <p class="mb-4">
    Cancellation policies for Hosts If you are a Host or want to learn more
    about what cancellation policies are available, please refer to cancellation
    policies for your listing.
  </p>
  <p class="mb-4">
    Issues while you're on a trip If you encounter issues when you arrive at
    your listing that the Host cannot resolve quickly, you may be protected
    under our Rebooking and Refund Policy.
  </p>
</div>
<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
